import QRious from 'qrious'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

interface QRAttrs {
    url: string
}

export default class QR extends MithrilComponent<QRAttrs> {
    url: string

    constructor(vnode: m.Vnode<QRAttrs>) {
        super()
        this.url = vnode.attrs.url
    }

    view() {
        return (
            <div className='c-auth-qr'>
                <canvas
                    oncreate={(canvasVnode: m.VnodeDOM) => {
                        const qr = new QRious({
                            element: canvasVnode.dom,
                            size: 200,
                            value: this.url,
                        })
                        void qr
                    }}
                />
            </div>
        )
    }
}
